import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./tag-list-widget.html';

    function TagListWidget(params) {
        this.tags = params.tags;
    }

    export default { viewModel: TagListWidget, template: templateMarkup};
